import { CHANGE_CLIENT_VIEW, RESET_CLIENT_VIEW } from '../actions/client_view_actions';

const clientViewReducer = (oldState = { isClientView: true }, action) => {
	Object.freeze(oldState);
	switch (action.type) {
		case CHANGE_CLIENT_VIEW:
			return {
				...oldState,
				isClientView: action.isClientView,
			};
		case RESET_CLIENT_VIEW:
			return {
				...oldState,
				isClientView: true,
			};
		default:
			return oldState;
	}
};

export default clientViewReducer;
